/* AnneBebe — FAQ produs
   Nu citește Globo, nu modifică formularul și nu trimite tracking.
   Singura funcție: copiază ghidul de mărimi deja randat de tema produsului
   în întrebarea corespunzătoare, la prima deschidere.
*/
(function () {
  'use strict';

  function cloneSizeChart(root) {
    if (!root) return;

    var productId = root.getAttribute('data-abpf-product-id');
    if (!productId) return;

    var target = root.querySelector(
      '[data-abpf-size-target][data-product-id="' + productId + '"]'
    );

    if (!target || target.getAttribute('data-abpf-size-loaded') === 'true') {
      return;
    }

    var source = document.querySelector(
      'template[data-abpf-sizechart-source][data-product-id="' + productId + '"]'
    );

    if (!source || !source.content || !source.content.childNodes.length) {
      return;
    }

    target.innerHTML = '';
    target.appendChild(source.content.cloneNode(true));
    target.setAttribute('data-abpf-size-loaded', 'true');
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-abpf-initialized') === 'true') {
      return;
    }

    root.setAttribute('data-abpf-initialized', 'true');

    var sizeQuestion = root.querySelector('[data-abpf-size-question]');
    if (!sizeQuestion) return;

    sizeQuestion.addEventListener('toggle', function () {
      if (sizeQuestion.open) {
        cloneSizeChart(root);
      }
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-abpf-root]');
    for (var i = 0; i < roots.length; i += 1) {
      initRoot(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
